import { component } from 'picoapp';

export default component(async (node) => {
  const initSlider = async () => {
    const { default: Swiper, FreeMode, Navigation } = (await import(
      /* webpackChunkName: "swiper" */
      'modules/swiper'
    ));

    const swiper = new Swiper(node, {
      modules: [FreeMode, Navigation],
      slidesPerView: 'auto',
      freeMode: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
        disabledClass: 'slider-arrow--disabled',
      },
    });

    swiper.init();
  };

  const init = () => {
    initSlider();
  };

  init();
});
